const styles = (theme) => ({
  border: {
    boxSizing: 'border-box',
    boxShadow: '0 1px 2px #e0e0e0',
  },
})

export default styles
